import React from 'react';
import ReactDOM from 'react-dom';

// Required for Redux store setup
import { Provider } from 'react-redux'
//import { Router, Route,browserHistory, Switch } from 'react-router';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { syncHistoryWithStore, routerReducer } from 'react-router-redux'
import configureStore from './store';

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';   

import './index.css';
import App from './App';
import Contactus from './component/Contactus';
import Donate from './component/Donate';
import Thankyou from './component/Thankyou';
import Volunteer from './component/Volunteer';
import CMSpage from './component/CMSpage';
import Takeapledge from './component/Takeapledge';
import Programmes from './component/Programmes';
import Applynow from './component/Applynow';
import Programmedetails from './component/Programmedetails';
import registerServiceWorker from './registerServiceWorker';
//const history = syncHistoryWithStore(browserHistory, configureStore)
const SITE_URL = process.env.REACT_APP_SITE_URL;


ReactDOM.render(
  <BrowserRouter basename={SITE_URL}>

		<Switch>
			 <Route exact path="/" component={App} />
			 <Route exact path="/Home" component={App} />
			<Route exact path="/Contact-us" component={Contactus} />
			<Route exact path="/Donate" component={Donate} />
			<Route path="/Volunteer" component={Volunteer} />
			<Route exact path="/about-us" component={CMSpage} />
			<Route exact path="/Take-a-Pledge" component={Takeapledge} />
			<Route exact path="/thankyou" component={Thankyou} />
			<Route exact path="/Programmes" component={Programmes} />
			<Route exact path="/apply-now" component={Applynow} />
			<Route exact path="/terms" component={CMSpage} />
			<Route exact path="/privacy-policy" component={CMSpage} />
			<Route exact path="/Programmes/:id" component={Programmedetails} />
			
		</Switch>

  </BrowserRouter>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js